import type { SecondsDuration,} from "@bracket/types";

/**
 * Attempts to reload the window if enough time has passed since the last reload.
 * Ensures there is at least `min_time_between_reloads` (in seconds) between reloads to avoid rapid loops.
 * Tracks the last reload timestamp in localStorage ("last-reload-time").
 * Throws the provided error if a reload is attempted before the minimum time has elapsed.
 *
 * @param {Error | AggregateError} error
 *        The error to throw if attempting reload too soon. Defaults to a generic Error if not provided.
 * @param {SecondsDuration} min_time_between_reloads
 *        The minimum time (in seconds) allowed between reloads. Defaults to 180 seconds.
 * @throws {Error|AggregateError} If reload is attempted too soon after the last reload.
 */
export const performManagedReload = (error: Error | AggregateError = new Error("Unknown error"), min_time_between_reloads: SecondsDuration = 180): true => {
	const last_reload_time = globalThis.localStorage.getItem("last-reload-time") || 0;
	if(last_reload_time && Date.now() - Number(last_reload_time) < (min_time_between_reloads * 1000)) {
		throw error;
	}
	globalThis.localStorage.setItem("last-reload-time", Date.now().toString());
	globalThis.localStorage.setItem("min_time_between_reloads", min_time_between_reloads.toString());
	window.location.reload();
	return true;
};
